import React, { useEffect, useState } from 'react';
import { COURSE_IMAGES } from '../../config/courseImages';

const DEFAULT_COURSE_COVER = COURSE_IMAGES.courseCard;

interface CourseCoverImageProps {
  src?: string | null;
  alt?: string;
  className?: string;
  /** Used when src is empty or fails to load. Defaults to the course card image. */
  fallbackSrc?: string;
}

const CourseCoverImage: React.FC<CourseCoverImageProps> = ({
  src,
  alt = '',
  className = 'h-40 w-full object-cover',
  fallbackSrc = DEFAULT_COURSE_COVER,
}) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const url = src && !failed ? src : fallbackSrc;

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      onError={() => {
        if (url !== fallbackSrc) setFailed(true);
      }}
    />
  );
};

export default CourseCoverImage;
